import 'rxjs/add/observable/throw';

import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { ExecutingUnit } from '../entities/executingUnit';

@Injectable()
export class ExecutingUnitService extends BaseCrudService<ExecutingUnit> {

    public uri = '/api/executingUnit/';

    constructor(injector: Injector) {
        super(injector);
       //console.log('Instance ExecutingUnitService');
    }

    buildSentence(entity?: ExecutingUnit, event?: LazyLoadEvent): HttpParams {
        if (entity) {
            let query = entity.code ? 'code' + QueryOperator.Contain + entity.code + QueryOperator.Split : QueryOperator.Empty;
            query = query.concat(
                entity.name ? 'name'
                + QueryOperator.Contain
                + entity.name
                + QueryOperator.Split : QueryOperator.Empty
            );
            query = query.concat(
                entity.abbreviation ? 'abbreviation'
                + QueryOperator.Contain
                + entity.abbreviation
                + QueryOperator.Split : QueryOperator.Empty
            );
            query = query.concat(
                entity.startDate ? 'startDate'
                + QueryOperator.Contain
                + entity.startDate
                + QueryOperator.Split : QueryOperator.Empty
            );
            this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
        }

        if (event) {
            const page = ((event.first + event.rows) / event.rows - 1 ).toString();
            const size = event.rows.toString();
            this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
            this.httpParams =  this.httpParams.set(QueryOperator.SizeParam, size);
        }
        return this.httpParams;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/executing-unit.service.ts